import React from 'react';

interface OrderPreparationIconProps {
  className?: string;
  size?: number;
}

/**
 * Ícono de "Preparación de órdenes"
 * 
 * DESCRIPCIÓN VISUAL:
 * - Dos cajas/estantes apilados uno sobre el otro
 * - Caja inferior: más grande, rectangular
 * - Caja superior: más pequeña, centrada sobre la inferior
 * - Ambas tienen líneas internas que sugieren compartimentos o estantes
 * - Representa organización de pedidos, almacenamiento o preparación
 * - Estilo minimalista, líneas limpias
 * - Simboliza el proceso de preparación de órdenes en almacén
 * 
 * Usa currentColor para adaptarse automáticamente al tema light/dark
 */
export const OrderPreparationIcon: React.FC<OrderPreparationIconProps> = ({
  className = '',
  size = 150,
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 150 150"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M98.4375 4.6875C106.201 4.6875 112.5 10.9863 112.5 18.75V51.5625H117.188V18.75C117.188 8.4082 108.779 0 98.4375 0H51.5625C41.2207 0 32.8125 8.4082 32.8125 18.75V51.5625H37.5V18.75C37.5 10.9863 43.7988 4.6875 51.5625 4.6875H60.9375V23.4375C60.9375 28.623 65.127 32.8125 70.3125 32.8125H79.6875C84.873 32.8125 89.0625 28.623 89.0625 23.4375V4.6875H98.4375ZM65.625 4.6875H84.375V23.4375C84.375 26.0156 82.2656 28.125 79.6875 28.125H70.3125C67.7344 28.125 65.625 26.0156 65.625 23.4375V4.6875ZM92.5488 150H131.25C141.592 150 150 141.592 150 131.25V84.375C150 74.0332 141.592 65.625 131.25 65.625H92.5488C93.5742 67.0898 94.4824 68.6719 95.2734 70.3125H117.188V89.0625C117.188 91.6406 115.078 93.75 112.5 93.75H98.4375V98.4375H112.5C117.686 98.4375 121.875 94.248 121.875 89.0625V70.3125H131.25C139.014 70.3125 145.312 76.6113 145.312 84.375V131.25C145.312 139.014 139.014 145.312 131.25 145.312H95.2734C94.4824 146.953 93.5742 148.535 92.5488 150ZM65.625 70.3125C73.3887 70.3125 79.6875 76.6113 79.6875 84.375V131.25C79.6875 139.014 73.3887 145.312 65.625 145.312H18.75C10.9863 145.312 4.6875 139.014 4.6875 131.25V84.375C4.6875 76.6113 10.9863 70.3125 18.75 70.3125H28.125V89.0625C28.125 94.248 32.3145 98.4375 37.5 98.4375H46.875C52.0605 98.4375 56.25 94.248 56.25 89.0625V70.3125H65.625ZM32.8125 70.3125H51.5625V89.0625C51.5625 91.6406 49.4531 93.75 46.875 93.75H37.5C34.9219 93.75 32.8125 91.6406 32.8125 89.0625V70.3125ZM65.625 65.625H18.75C8.4082 65.625 0 74.0332 0 84.375V131.25C0 141.592 8.4082 150 18.75 150H65.625C75.9668 150 84.375 141.592 84.375 131.25V84.375C84.375 74.0332 75.9668 65.625 65.625 65.625Z"
        fill="currentColor"
      />
    </svg>
  );
};

